const US_STATE_PATTERN = /\b(AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY|DC)\b/;

export const formatGoogleAddressCityState = address => {
  if (!address || typeof address !== 'string') return '';

  const parts = address
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

  if (parts.length < 2) return address;

  const stateIndex = parts.findIndex(part => US_STATE_PATTERN.test(part));
  if (stateIndex <= 0) return address;

  const stateMatch = parts[stateIndex].match(US_STATE_PATTERN);
  const firstPart = parts[0];
  const state = stateMatch?.[1];

  return firstPart && state ? `${firstPart}, ${state}` : address;
};

export const normalizeLocationAttachment = location => {
  if (!location) return null;

  const address = location.address || location.name || '';
  const displayName =
    location.displayName || formatGoogleAddressCityState(address) || location.name || address;

  return {
    ...location,
    name: displayName,
    address,
  };
};
